import { DropdownMenuItem } from "../ui/dropdown-menu";

import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { TableCell } from "../ui/table";
import { Action } from "./types";

export const TableActions = <DataType,>({
  actions,
  item,
}: {
  actions?: Action<DataType>[];
  item: DataType;
}) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <TableCell className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger
          hideChevron
          size="sm"
          className="border-0 p-0 shadow-none"
        >
          <Button size="icon" variant="ghost">
            <DotsHorizontalIcon className="h-5 w-5 rotate-90" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {actions.map((action, actionIndex) => {
            const shouldRender = action.showIf ? action.showIf(item) : true;

            return shouldRender ? (
              <DropdownMenuItem
                key={actionIndex}
                className={`flex w-full cursor-pointer items-center ${
                  action.className || ""
                }`}
                onClick={() => action.onClick(item)}
              >
                {action.icon && <span className="mr-2">{action.icon}</span>}
                {action.label}
              </DropdownMenuItem>
            ) : null;
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </TableCell>
  );
};
